module.exports = __webpack_public_path__ + "static/media/newsletter-april-2023-3.93f4071a.jpg";